import { Observable } from "rxjs";
import { inject, injectable } from "tsyringe";
import { HttpClient } from "src/infra/http/client";
import { autoBind } from "src/shared/decorators/autobind";
import { Environment } from "src/libs/environment";

@injectable()
export class PolicyRepository {
    constructor(@inject("HttpClient") private http: HttpClient) {}

    @autoBind
    getPolicies(userIdentity: string, line = "all"): Observable<Array<object>> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            userIdentity,
            "MEP"
        );
        const url = PolicyRepository.getPoliciesUrl(userIdentity, line);
        return this.http.getJSON<object[]>(url, {
            isPublicRequest: false,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    /**
     * This is the new ms for policy listing
     */
    getStandardPolicies(userIdentity: string): Observable<Array<object>> {
        const host = Environment.string("APIMGMT_URL");
        const url = PolicyRepository.getStandardPoliciessUrl();
        return this.http.getJSON(url, {
            host,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...this.http.httpUtils.getMsBaseHeaders(userIdentity),
            },
        });
    }

    @autoBind
    getPlans(userIdentity: string): Observable<Array<object>> {
        const headers = this.http.httpUtils.getMsBaseHeaders(
            userIdentity,
            "MEP"
        );
        const url = PolicyRepository.getPlansUrl(userIdentity);
        return this.http.getJSON<object[]>(url, {
            isPublicRequest: false,
            customHeader: {
                ...this.http.httpUtils.getBaseHeaders(),
                ...headers,
            },
        });
    }

    // obtiene la URL para obtener las policies de acuerdo a la línea de negocio
    private static getPoliciesUrl(userIdentity: string, line = "all"): string {
        return `insureds/${userIdentity}/insurances/${line}/policies`;
    }

    // obtiene la URL para obtener las policies de acuerdo a la línea de negocio
    private static getStandardPoliciessUrl(): string {
        return `ux-consulta-seguros-pga/mep/servicio-al-cliente/v1/api/seguros`;
    }

    private static getPlansUrl(userIdentity: string): string {
        return `insureds/${userIdentity}/insurances/eps/plans`;
    }
}
